var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 158.716,
    viewBox: "0 0 1920 158.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layered-waves-haikei",
    transform: "translate(0 -322.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,337.762l53.333,1.426c53.333,1.426,160,4.279,266.667,6.276s213.333,3.138,320,3.423,213.333-.285,320,2,213.333,7.417,320,1.141,213.333-23.964,320-28.129c106.667-4.222,213.333,5.135,266.667,9.757L1920,338.332V481.545H0Z",
    transform: "translate(0 0)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M0,364l53.333,1.715c53.333,1.715,160,5.146,266.667,11.549,106.667,6.346,213.333,15.723,320,20.755s213.333,5.832,320-1.315,213.333-22.241,320-26.415,213.333,2.459,320,6.118c106.667,3.6,213.333,4.174,266.667,4.46l53.333.286V499.506H0Z",
    transform: "translate(0 -17.961)",
    fill: "#ff7e39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,404l53.333,5.046c53.333,5.1,160,15.195,266.667,18.348s213.333-.631,320-1.491,213.333,1.2,320-1.835,213.333-11.3,320-15.195,213.333-3.555,320,3.039,213.333,19.438,266.667,25.8L1920,444.137v72.819H0Z",
    transform: "translate(0 -35.411)",
    fill: "#ff6144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,492.236l53.333-2.819c53.333-2.819,160-8.456,266.667-10.429s213.333-.282,320-.451c106.667-.225,213.333-2.255,320-4.9s213.333-5.807,320-5.637,213.333,3.777,320,5.525c106.667,1.8,213.333,1.8,266.667,1.8H1920v67.65H0Z",
    transform: "translate(0 -61.429)",
    fill: "#ff4053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M0,511.255l53.333,2.65c53.333,2.593,160,7.893,266.667,9.02s213.333-1.917,320-1.8,213.333,3.27,320,3.5c106.667.169,213.333-2.65,320-2.65s213.333,2.819,320,1.128,213.333-7.892,266.667-10.993L1920,509v51.865H0Z",
    transform: "translate(0 -79.32)",
    fill: "#f06"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.7c319503367ce0191b6590a171fc2659.svg";
export { ForwardRef as ReactComponent };